module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1029-f2feffe50d6a61ff68b1ce2d4752960c.png";